import { IDocumentEditable } from ".";
import { IItem, instanceOfISourceEditable, ISourceEditable } from "../../../domain/document/items";

export class SourceApplicator {
  constructor(private _document: IDocumentEditable) {
  }

  public applicate(original: IItem, updated: IItem, newlyUpdated: IItem, itemSetId: number): void {
    if (instanceOfISourceEditable(original) && instanceOfISourceEditable(updated) && (original.source !== updated.source)) {
      // 同じソースを見てるソース編集がいるなら同時に同じソースで更新する.
      for (const item of this._document.itemSets[itemSetId].items) {
        if (instanceOfISourceEditable(item) && (item.privateId !== updated.privateId) && !!item.source && (item.source !== updated.source) && (item.source.privateId === updated.source.privateId)) {
          const cloned = item.clone() as IItem & ISourceEditable;
          cloned.source = updated.source;
          this._document.updateItem(cloned, {
            itemSetId, 
          });
        }
      }
      // ソース編集されてる場合はソースも更新する.
      this._document.updateItem(updated.source, {
        itemSetId,
      });
    }
    // ソース編集対象が更新された場合は参照してるソース編集も更新する.
    for (const item of this._document.itemSets[itemSetId].items) {
      if (instanceOfISourceEditable(item) && !!item.source && (item.source.privateId === updated.privateId) && (item.source !== updated)) {
        const cloned = item.clone() as IItem & ISourceEditable;
        cloned.source = newlyUpdated;
        this._document.updateItem(cloned, {
          itemSetId,
        });
      }
    }
  }
}
